<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalBudget"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div class="card_title_1">
              <h5 style="text-transform: capitalize">{{ titleBudget }}</h5>
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <div>
              <div
                v-if="
                  dataBudget.achievement == null || dataBudget.trend == null
                "
                class="d-flex mt-2"
              >
                <div class="m-r-10">
                  {{ dataBudget.value }} {{ dataBudget.valueType }}
                </div>
                <div
                  v-if="dataBudget.achievement != null"
                  class="d-inline-flex align-items-center me-2"
                  :class="
                    dataBudget.achievementStatus === 'UP'
                      ? 'badge_green'
                      : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="
                      dataBudget.achievementStatus === 'UP' ? 'green' : 'red'
                    "
                    :type="
                      dataBudget.achievementStatus === 'UP'
                        ? 'arrow_up'
                        : 'arrow_down'
                    "
                  />
                  <div
                    class="data_detil"
                    v-bind:style="
                      dataBudget.achievementStatus === 'UP'
                        ? 'color: green;'
                        : 'color: red;'
                    "
                  >
                    {{ dataBudget.achievement }}
                  </div>
                </div>
                <div
                  v-if="dataBudget.trend != null"
                  class="d-inline-flex align-items-center"
                  :class="
                    dataBudget.trendStatus === 'UP'
                      ? 'badge_green'
                      : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="dataBudget.trendStatus === 'UP' ? 'green' : 'red'"
                    :type="
                      dataBudget.trendStatus === 'UP'
                        ? 'chart_up'
                        : 'chart_down'
                    "
                  />
                  <div
                    class="data_detil"
                    v-bind:style="
                      dataBudget.trendStatus === 'UP'
                        ? 'color: green;'
                        : 'color: red;'
                    "
                  >
                    {{ dataBudget.trend }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <apexchart
                height="400"
                width="100%"
                type="line"
                :options="chartOptions1"
                :series="series1"
              ></apexchart>
              <apexchart
                height="400"
                width="100%"
                type="line"
                :options="chartOptions2"
                :series="series2"
              ></apexchart>
              <apexchart
                height="400"
                width="100%"
                type="line"
                :options="chartOptions3"
                :series="series3"
              ></apexchart>
              <apexchart
                height="400"
                width="100%"
                type="line"
                :options="chartOptions4"
                :series="series4"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";

const apiDistribution = DistributionService.build();
export default {
  components: {
    IconSvg,
  },
  props: ["showModal", "dataBudget", "titleBudget"],
  data() {
    return {
      isActiveIdr: false,
      isActiveMonth: false,
      chartOptions1: {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false, // Hide toolbar
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%", // Adjust column width
          },
        },
        colors: [],
        xaxis: {
          categories: ["2021", "2022", "2023"],
        },
        yaxis: [
          // {
          //   title: {
          //     text: "Forecast",
          //   },
          // },
          // {
          //   opposite: true,
          //   title: {
          //     text: "Actual",
          //   },
          // },
        ],
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 1, 2],
        },
        legend: {
          show: true,
          position: "top",
          labels: {
            // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#ff5151",
            radius: 12,
          },
        },
        stroke: {
          width: 3, // Set different line widths for line and column series
          curve: "smooth", // Smoothen the line series
        },
        markers: {
          size: 6, // Set the size of the markers
          colors: ["#ff5151"], // Set the color of the markers
          strokeWidth: 1, // Set the width of the markers' border
        },
      },
      chartOptions2: {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false, // Hide toolbar
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%", // Adjust column width
          },
        },
        colors: [],
        xaxis: {
          categories: ["Nov", "Dec", "Jan"],
        },
        yaxis: [
          // {
          //   title: {
          //     text: "Forecast",
          //   },
          // },
          // {
          //   opposite: true,
          //   title: {
          //     text: "Actual",
          //   },
          // },
        ],
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 1, 2],
        },
        legend: {
          show: true,
          position: "top",
          labels: {
            // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#ff5151",
            radius: 12,
          },
        },
        stroke: {
          width: 3, // Set different line widths for line and column series
          curve: "smooth", // Smoothen the line series
        },
        markers: {
          size: 6, // Set the size of the markers
          colors: ["#ff5151"], // Set the color of the markers
          strokeWidth: 1, // Set the width of the markers' border
        },
      },
      chartOptions3: {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false, // Hide toolbar
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%", // Adjust column width
          },
        },
        colors: [],
        xaxis: {
          categories: ["W0", "W-1", "W-2"],
        },
        yaxis: [
          // {
          //   title: {
          //     text: "Forecast",
          //   },
          // },
          // {
          //   opposite: true,
          //   title: {
          //     text: "Actual",
          //   },
          // },
        ],
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 1, 2],
        },
        legend: {
          show: true,
          position: "top",
          labels: {
            // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#ff5151",
            radius: 12,
          },
        },
        stroke: {
          width: 3, // Set different line widths for line and column series
          curve: "smooth", // Smoothen the line series
        },
        markers: {
          size: 6, // Set the size of the markers
          colors: ["#ff5151"], // Set the color of the markers
          strokeWidth: 1, // Set the width of the markers' border
        },
      },
      chartOptions4: {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false, // Hide toolbar
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%", // Adjust column width
          },
        },
        colors: [],
        xaxis: {
          categories: ["D0", "D-1", "D-2"],
        },
        yaxis: [
          // {
          //   title: {
          //     text: "Forecast",
          //   },
          // },
          // {
          //   opposite: true,
          //   title: {
          //     text: "Actual",
          //   },
          // },
        ],
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 1, 2],
        },
        legend: {
          show: true,
          position: "top",
          labels: {
            // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#ff5151",
            radius: 12,
          },
        },
        stroke: {
          width: 3, // Set different line widths for line and column series
          curve: "smooth", // Smoothen the line series
        },
        markers: {
          size: 6, // Set the size of the markers
          colors: ["#ff5151"], // Set the color of the markers
          strokeWidth: 1, // Set the width of the markers' border
        },
      },
      modal: null,
      series1: [],
      series2: [],
      series3: [],
      series4: [],
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalBudget);
  },

  methods: {
    idr() {
      this.isActiveIdr = !this.isActiveIdr;
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
    async getDataChart() {
      this.dataBudget;
      let param = Object.assign({
        instance: this.dataBudget.metricId,
      });
      const res = await apiDistribution.getDataDistributionBudgetSummaryCard(
        param
      );
      const data = res.data.data[0];
      const year = [
        {
          color: "#ff5151",
          name: "Target",
          type: "line",
          data: data.yearlyTarget,
        },
        {
          // color:"#8099D9",
          name: "Actual",
          type: "line",
          data: data.yearly,
        },
      ];
      const month = [
        {
          color: "#ff5151",
          name: "Target",
          type: "line",
          data: data.monthlyTarget,
        },
        {
          // color:"#8099D9",
          name: "Actual",
          type: "line",
          data: data.monthly,
        },
      ];
      const week = [
        {
          color: "#ff5151",
          name: "Target",
          type: "line",
          data: data.weeklyTarget,
        },
        {
          // color:"#8099D9",
          name: "Actual",
          type: "line",
          data: data.weekly,
        },
      ];
      const day = [
        {
          color: "#ff5151",
          name: "Target",
          type: "line",
          data: data.dailyTarget,
        },
        {
          // color:"#8099D9",
          name: "Actual",
          type: "line",
          data: data.daily,
        },
      ];
      this.series1 = year;
      this.series2 = month;
      this.series3 = week;
      this.series4 = day;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  watch: {
    async showModal() {
      if (this.showModal) {
        this.getDataChart();
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style lang="scss">
.custom_header {
  padding: 1rem 1rem 0rem 1rem;
  border-bottom: unset;

  .custom_header_content {
    width: 100%;
    position: relative;

    .close_btn {
      position: absolute;
      right: 0;
      z-index: 999;
    }

    .tahun_text {
      font-size: 20px;
      font-weight: 400;
      line-height: 23px;
    }

    .judul_text {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}

.custom-modal-width {
  max-width: 564px;
  width: 100%;
}

.tabs {
  color: #838383;
  font-size: 14px;
  padding: 5px;
  cursor: pointer;
}

.tabs_active {
  color: #00a3e9;
  border-bottom: 3px solid #00a3e9;
}

.custom_pb {
  background: unset !important;
  height: 8px;
}
</style>
